var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "sidebar-menu-container" }, [
    _c("div", { staticClass: "sidebar-main-label" }, [
      _vm._v("Редактировать дизайн")
    ]),
    _vm._v(" "),
    _vm.version !== "lite"
      ? _c("div", { staticClass: "design-name-input-grid" }, [
          _c("div", [
            _c("div", { staticClass: "ap-modal-input-name" }, [
              _vm._v("\n                Название дизайна\n            ")
            ]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.designName,
                  expression: "designName"
                }
              ],
              staticClass: "cd-modal-text-input",
              attrs: { type: "text" },
              domProps: { value: _vm.designName },
              on: {
                input: [
                  function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.designName = $event.target.value
                  },
                  function($event) {
                    return _vm.nameIsChanged()
                  }
                ]
              }
            })
          ]),
          _vm._v(" "),
          _vm.nameNotSaved
            ? _c(
                "div",
                {
                  staticClass: "gl-square-btn btn-red design-name-button",
                  attrs: { title: "Сохранить название" },
                  on: {
                    click: function($event) {
                      return _vm.saveDesignName()
                    }
                  }
                },
                [_c("SVGChecked2", { staticClass: "svg-14" })],
                1
              )
            : _c(
                "div",
                {
                  staticClass: "gl-square-btn btn-disabled design-name-button",
                  attrs: { title: "Название не изменялось" }
                },
                [_c("SVGChecked2", { staticClass: "svg-14" })],
                1
              )
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "sidebar-step-two-img-container" }, [
      _c("img", {
        staticClass: "sidebar-step-two-img",
        attrs: { src: _vm.urlForStatic("/img/select_plane.png") }
      })
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "sidebar-text-area" }, [
      _vm._v("\n        Выберите\n        "),
      _c("span", { staticClass: "red-text bold-text" }, [
        _vm._v("кликом в рабочей области")
      ]),
      _vm._v(
        "\n        плоскость, материал для которой вы хотите изменить.\n    "
      )
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }